import React from 'react';
import { useTranslation } from '@corti/i18n';
import { PageHeader, PageHeaderTitle } from 'lib/cortiUI';
export function Header() {
    const { t } = useTranslation('caseReviewRequestsModule');
    return (React.createElement(PageHeader, { mb: 0 },
        React.createElement(PageHeaderTitle, null, t('appName', 'Review Queue'))));
}
